<template>
	<section class="bg-white">
		<div class="container">
			<p class="strptxt">
				<span>Compare Rates From Top Insurance Providers</span>
			</p>
			<ul class="strp-list row">
				<li class="col-12 col-md-6">
					<img src="/img/strp-img1.png" />
				</li>
				<li class="col-12 col-md-6">
					<img src="/img/strp-img2.png" />
				</li>
			</ul>
		</div>
	</section>
</template>

<script>
export default {};
</script>